import app from '@motionelements/core/src/store/modules/app.js';

export default {
  namespaced: true,
  state: () => ({
    ...app.state,
    overlayShown: false,
    ctaMobileMenuShown: false,
  }),
  getters: app.getters,
  actions: app.actions,
  mutations: {
    ...app.mutations,
    toggleOverlay(state, boolean) {
      state.overlayShown = boolean;
    },
    toggleCtaMobileMenu(state, boolean) {
      state.ctaMobileMenuShown = boolean;
    },
  },
};
